import React from 'react';
import { Link } from "react-router-dom";

export const Offer = () => {
	return (
		<div className="xl:my-16 my-8"><Link to="#"><img src="images/offer.gif" alt="60% Off" /></Link></div>
	)
}
